import React from "react";

import Brightness7Icon from "@material-ui/icons/Brightness7";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

import { useThemeMode } from "common/ThemeModeContext";

// Navbar sun/moon switch that flips the app between light and dark mode.
export default function ThemeToggle({ className }) {
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === "dark";

  return (
    <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      <IconButton
        size="small"
        onClick={toggleMode}
        aria-label="toggle light/dark theme"
        className={className}
      >
        {isDark ? (
          <Brightness7Icon style={{ color: "#eaa745" }} />
        ) : (
          <Brightness4Icon style={{ color: "#3C4858" }} />
        )}
      </IconButton>
    </Tooltip>
  );
}
